<template>
  <svg
    v-if="name == 'instagram'"
    :class="'ic_' + name"
    :style="customStyle"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.00353 4.37845C6.45027 4.37845 4.37867 6.44991 4.37867 9.00331C4.37867 11.5567 6.45027 13.6282 9.00353 13.6282C11.5569 13.6282 13.6284 11.5567 13.6284 9.00331C13.6284 6.44991 11.5569 4.37845 9.00353 4.37845ZM9.00353 12.0033C7.3471 12.0033 6.0035 10.6599 6.0035 9.00331C6.0035 7.34675 7.3471 6.00328 9.00353 6.00328C10.6601 6.00328 12.0036 7.34675 12.0036 9.00331C12.0036 10.6599 10.6601 12.0033 9.00353 12.0033Z"
      fill="url(#paint0_linear_5092_37345)"
    />
    <path
      d="M13.8113 5.27549C14.4077 5.27549 14.8912 4.79204 14.8912 4.1958C14.8912 3.59942 14.4077 3.1161 13.8113 3.1161C13.2151 3.1161 12.7316 3.59942 12.7316 4.1958C12.7316 4.79204 13.2151 5.27549 13.8113 5.27549Z"
      fill="url(#paint1_linear_5092_37345)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.9543 5.29308C17.9121 4.33649 17.7574 3.67884 17.5358 3.10897C17.3072 2.50408 16.9555 1.96251 16.4947 1.51231C16.0445 1.0551 15.4994 0.699828 14.9015 0.474795C14.3283 0.253196 13.6741 0.0985034 12.7175 0.0563269C11.7538 0.0105785 11.4478 0 9.0035 0C6.55919 0 6.25324 0.0105785 5.29308 0.052755C4.33648 0.0949315 3.67883 0.249762 3.1091 0.471223C2.50407 0.699828 1.96251 1.05153 1.51231 1.51231C1.0551 1.96251 0.699964 2.50765 0.474794 3.10554C0.253196 3.67884 0.0985033 4.33292 0.0563268 5.28951C0.0105784 6.25325 0 6.5592 0 9.00352C0 11.4478 0.0105784 11.7538 0.0527549 12.714C0.0949313 13.6705 0.249761 14.3282 0.471359 14.8981C0.699964 15.503 1.0551 16.0445 1.51231 16.4947C1.96251 16.9519 2.50764 17.3072 3.10553 17.5322C3.67883 17.7538 4.33291 17.9085 5.28964 17.9507C6.24967 17.993 6.55576 18.0035 9.00007 18.0035C11.4444 18.0035 11.7503 17.993 12.7105 17.9507C13.6671 17.9085 14.3247 17.7538 14.8945 17.5322C16.1044 17.0645 17.061 16.1079 17.5288 14.8981C17.7502 14.3248 17.9051 13.6705 17.9472 12.714C17.9894 11.7538 18 11.4478 18 9.00352C18 6.5592 17.9964 6.25325 17.9543 5.29308ZM16.333 12.6436C16.2943 13.5229 16.1466 13.9977 16.0235 14.3142C15.721 15.0985 15.0985 15.721 14.3142 16.0235C13.9976 16.1466 13.5194 16.2943 12.6436 16.3329C11.694 16.3752 11.4092 16.3856 9.00708 16.3856C6.60494 16.3856 6.31658 16.3752 5.37042 16.3329C4.49117 16.2943 4.01638 16.1466 3.69985 16.0235C3.30955 15.8793 2.95427 15.6506 2.66591 15.3517C2.36696 15.0598 2.13836 14.7081 1.99411 14.3178C1.87101 14.0012 1.72333 13.5229 1.68472 12.6472C1.64241 11.6976 1.63197 11.4127 1.63197 9.01052C1.63197 6.60839 1.64241 6.32002 1.68472 5.374C1.72333 4.49475 1.87101 4.01996 1.99411 3.70343C2.13836 3.31299 2.36696 2.95785 2.66948 2.66935C2.96128 2.3704 3.31298 2.1418 3.70342 1.99768C4.01995 1.87459 4.49832 1.7269 5.37399 1.68816C6.32358 1.64598 6.60851 1.6354 9.01051 1.6354C11.4162 1.6354 11.701 1.64598 12.6472 1.68816C13.5264 1.7269 14.0012 1.87459 14.3177 1.99768C14.708 2.1418 15.0633 2.3704 15.3517 2.66935C15.6506 2.96129 15.8792 3.31299 16.0235 3.70343C16.1466 4.01996 16.2943 4.49819 16.333 5.374C16.3752 6.32359 16.3858 6.60839 16.3858 9.01052C16.3858 11.4127 16.3752 11.694 16.333 12.6436Z"
      fill="url(#paint2_linear_5092_37345)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5092_37345"
        x1="15.753"
        y1="0.900174"
        x2="1.80034"
        y2="17.5534"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9000DC" />
        <stop offset="0.27479" stop-color="#C610AF" />
        <stop offset="0.491843" stop-color="#F71F87" />
        <stop offset="0.723714" stop-color="#FE5265" />
        <stop offset="1" stop-color="#FED619" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5092_37345"
        x1="15.753"
        y1="0.900174"
        x2="1.80034"
        y2="17.5534"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9000DC" />
        <stop offset="0.27479" stop-color="#C610AF" />
        <stop offset="0.491843" stop-color="#F71F87" />
        <stop offset="0.723714" stop-color="#FE5265" />
        <stop offset="1" stop-color="#FED619" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5092_37345"
        x1="15.753"
        y1="0.900174"
        x2="1.80034"
        y2="17.5534"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9000DC" />
        <stop offset="0.27479" stop-color="#C610AF" />
        <stop offset="0.491843" stop-color="#F71F87" />
        <stop offset="0.723714" stop-color="#FE5265" />
        <stop offset="1" stop-color="#FED619" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script lang="js">
export default {
  props: {
    name: {
      type: String,
      default:null,
    },
    color: {
      type: String,
      default: "#394150",
    },
     strokeWidth:{
        type: String,
      default: "1",
    },secondColor: {
      type: String,
      default: "#E5E7EB",
    },
    sizeType:{
        type: String,
        default: '24',
    },
    customStyle:{default:{}}
  },
  watch: {
  },
  data() {
    return {
      _root: this,
    };
  },
  methods: {},
  destroyed() {},
};
</script>
<style scoped>
@media only screen and (min-width: 280px) {
}
</style>
